import React from "react";

const CryptoAirdrop = () => {
  const airdrops = [
    {
      title:
        "Solayer (LAYER) Airdrop Continues: Third Tillionx HODLer Airdrops Announced – Earn LAYER With Retroactive BNB Simple Earn Subscriptions (2025-08-18)",
      date: "2025-08-18",
    },
    {
      title:
        "Solayer (LAYER) Airdrop Continues: Second Tillionx HODLer Airdrops Announced – Earn LAYER With Retroactive BNB Simple Earn Subscriptions (2025-06-16)",
      date: "2025-06-16",
    },
    {
      title:
        "Tillionx Will Support the Doodles (DOOD) Airdrop for MUBARAK, BROCCOLI714, TST, 1MBABYDOGE, and KOMA Holders",
      date: "2025-05-09",
    },
    {
      title:
        "Tillionx Has Completed the Wise Monkey (MONKY) Airdrop Distribution to FLOKI (FLOKI) and ApeCoin (APE)",
      date: "2024-12-20",
    },
    {
      title:
        "Tillionx Will Support the Wise Monkey (MONKY) Airdrop for FLOKI and APE Holders",
      date: "2024-12-02",
    },
    {
      title:
        "Tillionx Has Completed the Pepper (1000PEPPER) Airdrop Distribution to Chilliz (CHZ) Holders",
      date: "", // Date is not fully visible in the image
    },
  ];

  return <div>
    <div className="my-16 rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans">
      <nav className="flex items-center text-sm  mb-6">
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Cryto Airdrop</span>
        </nav>
      <h2 className="text-xl font-bold mb-6">Crypto Airdrop</h2>

      {/* Airdrops List */}
      {airdrops.map((item, index) => (
        <div key={index} className="py-4 border-b border-gray-200 last:border-b-0">
          <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
            {item.title}
          </h3>
          <p className="text-sm mt-1">{item.date}</p>
        </div>
      ))}
    </div>
  </div>;
};

export default CryptoAirdrop;
